import isomorphicUnfetch from 'isomorphic-unfetch'
import { isE2EMode } from '../utils'

// @explanation: Using different fetch for E2E testing.
// Explicit `window.fetch` is used in E2E mode so outgoing requests
// captured and deferred until the Service Worker is ready.
// Necessary due to Apollo hoisting a native window.fetch call,
// preventing Mock Service Worker (https://www.npmjs.com/package/msw) from properly capturing it.
// @sinslav

const fetchFn = isE2EMode() ? (...args) => fetch(...args) : isomorphicUnfetch

export default fetchFn
